import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import GlobalStyle from "./globalStyles";
import { ToastProvider } from "./ToastContext";
import Login from "./pages/login/Login";
import Register from "./pages/register/Register";
import Home from "./pages/home/Home";
import Profile from "./pages/profile/Profile";
import Search from "./pages/search/Search";
import Folders from "./pages/folders/Folders";
import Community from "./pages/community/Community";
import Landing from "./pages/landing/Landing";
import ChatWidget from "./components/ChatWidget";


const ProtectedRoute = ({ children }) => {
  const currentUser = useSelector((state) => state.user.currentUser);
  return currentUser ? children : <Navigate to="/" replace />;
};


const AuthRoute = ({ children }) => {
  const currentUser = useSelector((state) => state.user.currentUser);
  return currentUser ? <Navigate to="/home" replace /> : children;
};

function App() {
  return (
    <>
      <GlobalStyle />
      <ToastProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<AuthRoute><Landing /></AuthRoute>} />
            <Route
              path="/home"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route
              path="/login"
              element={
                <AuthRoute>
                  <Login />
                </AuthRoute>
              }
            />
            <Route
              path="/register"
              element={
                <AuthRoute>
                  <Register />
                </AuthRoute>
              }
            />
            <Route
              path="/profile/:userId"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/searchuser"
              element={
                <ProtectedRoute>
                  <Search />
                </ProtectedRoute>
              }
            />
            <Route
              path="/folders"
              element={
                <ProtectedRoute>
                  <Folders />
                </ProtectedRoute>
              }
            />
            <Route
              path="/community"
              element={
                <ProtectedRoute>
                  <Community />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <ChatWidget />
      </ToastProvider>
    </>
  );
}

export default App;
